import { createSelector } from 'reselect';
import ProApi from './ProApi';
import { receivedServerData } from '../../components/Common/Data/DataFetcher';
import createDeepEqualSelector from 'components/HelperModules/createDeepEqualSelector';
import { isBlank } from 'utils/isBlank';

export const PRO_NAMESPACE = 'pro';
export const PROS_NAMESPACE = 'pros';

export const getProsList = createSelector(
  (state) => state.pros,
  (pros) => {
    return pros || {};
  }
);

export const getPros = createSelector(getProsList, (prosList) => {
  return prosList.data || [];
});

export const getPro = createDeepEqualSelector(
  (state) => state.pro,
  (pro) => {
    return pro || {};
  }
);

export const getProUuid = createSelector(getPro, (pro) => {
  return pro.id;
});

export const getFirstName = createSelector(getPro, (pro) => {
  return pro.first_name;
});

export const getLastName = createSelector(getPro, (pro) => {
  return pro.last_name;
});

export const getFullName = createSelector(getPro, (pro) => {
  return pro.full_name;
});

export const proNameMissing = createSelector(getFirstName, getLastName, (firstName, lastName) => {
  return isBlank(firstName) || isBlank(lastName);
});

export const getEmail = createSelector(getPro, (pro) => {
  return pro.email || '';
});

export const getMobileNumber = createSelector(getPro, (pro) => {
  return pro.mobile_number;
});

export const avatarUrl = createSelector(getPro, (pro) => pro.avatar_url);

export const isImpersonated = createSelector(getPro, (pro) => {
  return pro.impersonated;
});

export const getPermissions = createSelector(getPro, (pro) => {
  return pro.permissions || {};
});

export const isAdmin = createSelector(getPro, (pro) => {
  return pro.is_admin;
});

export const hcpAssistImpersonated = createSelector(getPro, (pro) => {
  return pro.is_hcp_assist_impersonated;
});

export const showCompanySetup = createSelector(getPermissions, (permissions) => {
  return permissions.show_company_setup;
});

export const canEditEmployees = createSelector([isAdmin, showCompanySetup], (admin, showCompanySetup) => {
  return admin || showCompanySetup;
});

export const canEditPayDetails = createSelector(getPermissions, (permissions) => {
  return permissions.can_edit_pay_details;
});

export const canShowHomeData = createSelector(getPermissions, (permissions) => {
  return permissions.can_see_home_data;
});

export const canShowReporting = createSelector(getPermissions, (permissions) => permissions.show_reporting);

export const canShowJobCostingSummary = createSelector(
  getPermissions,
  (permissions) => permissions.show_job_costing_summary
);

export const canAccessCommunicationSettings = createSelector(
  getPermissions,
  (permissions) => permissions.can_edit_communication_settings
);

export const isSuperPro = createSelector(getPro, (pro) => {
  return pro.is_super_pro || false;
});

export const getOrganizationCreatedAt = createSelector(getPro, (pro) => pro.organization_created_at || null);

export const showGetStartedChecklist = createSelector(
  getOrganizationCreatedAt,
  (date) => new Date(date) >= new Date('2021-10-14 12:00:00')
);

export const fetchPro = {
  fetchingApiFunc: ProApi.fetchPro,
  uniqueCacheKey: 'f01020d0-2afa-42f7-b98c-9dfb502342fd',
  selector: getPro,
  paramsFromProps: () => [],
  dataNamespace: PRO_NAMESPACE,
};

export const fetchPros = {
  fetchingApiFunc: ProApi.index,
  selector: getProsList,
  paramsFromProps: () => [],
  dataNamespace: PROS_NAMESPACE,
};

export function receivedProData(data) {
  return (dispatch) => {
    dispatch(receivedServerData(data, PRO_NAMESPACE));
  };
}
